import { render, staticRenderFns } from "./dettaglioPodismo.vue?vue&type=template&id=27646031"
import script from "./dettaglioPodismo.vue?vue&type=script&lang=js"
export * from "./dettaglioPodismo.vue?vue&type=script&lang=js"
import style0 from "./dettaglioPodismo.vue?vue&type=style&index=0&id=27646031&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports